import React, { useState } from 'react'
import { useNavigate , Link, json } from 'react-router-dom';


//URL
import {URL} from '../../context/URL'

//GoogleLogin
import { GoogleLogin } from '@react-oauth/google';
import Jwt_decode from 'jwt-decode';


//Alrt
import {SweetAlrt} from '../../context/SweetAlrt'

//Incript_password
import {Incript_password} from '../../context/Incript_password'

//css 
import './Login.css'




//mui
import { Typography  , styled  ,Alert , TextField} from '@mui/material';


  //css
  const AlrtBox = styled(Typography)(({theme})=>({
    color:'red',
    marginTop:'-18px',
    marginBottom:'5px',
    paddingLeft:'40px',
    fontSize:'15px',
    "@media (max-width:390px) ":{
        fontSize:'10px'
    }
}))




//main function 
export default function  Login (){

    const navigate = useNavigate();

    const [data , setData] = useState({email : "" , password:""});

    //alrt
    const [emailAlrt , setEmailAlrt] = useState(false)
    const [passwordAlrt , setPasswordAlrt] = useState(false)
    const [checkUser , setCheckUser] = useState(false);

       //logIn with google
       const onUser_Login_Success = async(res)=>{
        

        const All_data = Jwt_decode(res.credential)

        try{
            let incript_password = Incript_password(All_data.sub);
            let result = await fetch(`${URL}/user/findUser/${All_data.email}/${incript_password}`);
            result =await result.json();
            console.log("succes");
            if(result.length != 0){
                console.log(result)
                setCheckUser(false);

                SweetAlrt("Log in" , "success");
           
             navigate(`/Home`)
             localStorage.setItem('User' , JSON.stringify(result));
            }else{
             setCheckUser(true);
            }
         }catch(error){
            SweetAlrt("Log in" , "error");
             console.log("user find aip error : " + error);
         }

        
    }

    const onUser_Login_Error = (res)=>{
        console.log("Eror");
    }


    const handle_logIn = async()=>{
          //email validation
          if(data.email.length == 0){
            setEmailAlrt(true);
        }else{
            setEmailAlrt(false)
        }

        //password validation
        if(data.password.length == 0){
            setPasswordAlrt(true);
        }else{
            setPasswordAlrt(false);
        }

        
            if(!emailAlrt && !passwordAlrt ){
                if(data.email.length != 0 && data.password.length != 0){
                    try{
                        let incript_password = Incript_password(data.password);
                        let result = await fetch(`${URL}/user/findUser/${data.email}/${incript_password}`);
                        result =await result.json();

                        if(result.length != 0){
                            console.log(result)
                            setCheckUser(false);

                            SweetAlrt("Log in" , "success");
                       
                         navigate(`/Home`)
                         localStorage.setItem('User' , JSON.stringify(result));
                        }else{
                         setCheckUser(true);
                        }
                     }catch(error){
                        SweetAlrt("Log in" , "error");
                         console.log("user find aip error : " + error);
                     }
                    // navigate('/Home')
                }
            }
        
    }


   
    return (
        <>
            <div className="container" style={{background :  '#f2f2f2'}}>
            <div className="wrapper" style={{ background :'#FFFF'}}>
                <div className="title"><span>Login Form</span></div>
                <form>
                <div >
                    {
                    checkUser &&   <Alert severity="error" style={{margin : '0rem 0rem 1rem 0rem'}}>invaild email and password !</Alert>
                    }
                 </div>
                
             <div style={{marginBottom : '1rem'}}>
                {
                    emailAlrt ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Email"
                    onChange={(e)=>setData({...data , email : e.target.value})}
                    helperText="invaild email"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="Email"
                        onChange={(e)=>setData({...data , email : e.target.value})}
                    />
                }
             </div>

             
             <div style={{marginBottom : '1rem'}}>
                
               {
                 passwordAlrt ?  <TextField
                 error
                 color='info'
                 type='password'
                 style={{width : '100%'}}
                 id="outlined-error"
                 label="password"
                 onChange={(e)=>setData({...data , password : e.target.value})}
                 helperText="invalid password"
                /> 
                :
                 <TextField
                    color='info'
                    type='password'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Password"
                    onChange={(e)=>setData({...data , password : e.target.value})}
                />
               }
             </div>


                <div className="pass"><Link to={'/Email_verifiy/ForgetPassword'}>Forgot password?</Link></div>
                <div className="row button" >
                    <input type="button" value="Login" onClick={handle_logIn}/>
                </div>
               <div className="signup-link" style={{ color :'black' }}>Not a member? <Link to={'/Email_verifiy/SignUp'}>Signup now</Link></div>

               <p style={{textAlign : 'center' ,   marginTop:'1rem'}}>OR </p>

            <div style={{display: 'flex' , justifyContent: 'center' , width : '100%'}}>
                <GoogleLogin
                    onSuccess={(res)=>onUser_Login_Success(res)}
                    onError={(res)=>onUser_Login_Error(res)}
                />
            </div>
                </form>
            </div>
            </div>
           {/* <ActionAlerts mas/> */}
        </>
    )
}
